import { useDispatch } from 'react-redux';
import { ThunkDispatch } from 'redux-thunk';
import { Action } from 'redux';
import { useAsync } from 'react-use';
import { AsyncState } from 'react-use/lib/useAsyncFn';

import { RootState } from 'reducers';

import WBUAPI from './API';
import { RecentSale } from './utils';

export const useCustomerSalesHistory = (
  customerID: number | string,
): AsyncState<RecentSale[]> => {
  const dispatch: ThunkDispatch<RootState, any, Action> = useDispatch();
  return useAsync(async () => {
    if (customerID === undefined) throw new Error('No customer passed in');
    return dispatch(WBUAPI.getRecentSales({ customerID }));
  }, [customerID]);
};
